<script setup lang="ts"></script>

<template>
  <icon name="lucide:grip-vertical" />
</template>

<style scoped></style>
